/**
 * The password rule the server enforces everywhere (backend/src/utils/passwordPolicy.js):
 * at least 8 characters with an uppercase letter, a lowercase letter, a number and a symbol.
 */
export const PASSWORD_RULE =
  'At least 8 characters, with an uppercase letter, a lowercase letter, a number and a symbol';

const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;

/** @returns {string|null} what is wrong with the password, or null when it is fine */
export const passwordProblem = (password) => {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (password.length > 128) return 'Password cannot exceed 128 characters';
  return PASSWORD_PATTERN.test(password) ? null : `Password: ${PASSWORD_RULE.toLowerCase()}`;
};
